module.exports = __webpack_public_path__ + "img/tools_3.e61cd8bf.png";